import { domain } from 'modules/data';

import { FilterTrasferData } from '../../XeroAirwallexBatchPaymentForm.types';
import { tableSortOrderToSortingDirectionMap } from './XeroAirwallexBatchPaymentFormContent.constants';

export const mapFilterTransfer = (
    filterData: domain.AddBillsToBatchFilterData,
    sortingConfig: domain.AddBillsToBatchSortingConfig
): FilterTrasferData => {
    const { sortBy, sortOrder } = sortingConfig;

    const sortingDirection = tableSortOrderToSortingDirectionMap[sortOrder];

    const xeroContactId = {
        filteringValue: filterData.contactId || null,
        sortingType: sortBy === domain.AddBillsToBatchTableColumns.Supplier ? sortingDirection : null,
    };
    const reference = {
        filteringValue: filterData.reference || null,
    };
    const date = {
        filteringValue: {
            type: 0,
            custom: {
                greaterOrEqual: filterData.dateFrom?.toISOString() ?? null,
                lessOrEqual: filterData.dateTo?.toISOString() ?? null,
            },
        },
        sortingType: sortBy === domain.AddBillsToBatchTableColumns.Date ? sortingDirection : null,
    };
    const dueDate = {
        filteringValue: {
            type: 0,
            custom: {
                greaterOrEqual: filterData.dueDateFrom?.toISOString() ?? null,
                lessOrEqual: filterData.dueDateTo?.toISOString() ?? null,
            },
        },
        sortingType: sortBy === domain.AddBillsToBatchTableColumns.DueDate ? sortingDirection : null,
    };
    const plannedDate = {
        filteringValue: {
            type: 0,
            custom: {
                greaterOrEqual: filterData.plannedDateFrom?.toISOString() ?? null,
                lessOrEqual: filterData.plannedDateTo?.toISOString() ?? null,
            },
        },
        sortingType: sortBy === domain.AddBillsToBatchTableColumns.PlannedDate ? sortingDirection : null,
    };

    const amountDue = {
        filteringValue: {
            greaterOrEqual: filterData.amountFrom,
            lessOrEqual: filterData.amountTo,
        },
        sortingType: sortBy === domain.AddBillsToBatchTableColumns.AmountDue ? sortingDirection : null,
    };

    return {
        xeroContactId,
        reference,
        date,
        dueDate,
        plannedDate,
        amountDue,
        excludeReserved: filterData.excludeBillsWithZeroAmount,
    };
};
